module.exports = __webpack_public_path__ + "img/zk-icon-marketing.358ba959.svg";